import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import File from 'modules/bookkeepers/store/models/File'

export class Files extends Collection<File> {
  constructor(data: File[] = []) {
    super(data)
    makeObservable(this, {
      fromIncidenceMessage: computed,
    })
  }

  get indexes() {
    return ['incidence_message_id']
  }

  model() {
    return File
  }

  get fromIncidenceMessage(): File[] {
    return this.models.filter((file) => file.attributes.incidence_message_id)
  }
}

const singleton: Files = new Files()

export default singleton

const { provider: FilesProvider, hook: useFiles } = createCollectionContext<File, Files>()

export { FilesProvider, useFiles }
